import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useGenericFormMethods } from "Application/Pages/formMethods/genericMethods";
import { IIssue } from "Application/features/models/Issue/IIssue";
import { useSaveReportMutation, useUpdateReportMutation } from "Application/features/services/apis/Report/IssueApiService";
import { DocumentManagerActions, ShowInfoConfirmation, SibaDatePicker, SibaInput, SibaSelect, SmallScreenDialog } from "@siba/components";
import { growlWarning, userManagementUtil } from "@siba/utilities";
import { Card, CardActions, CardContent } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { createUseStyles } from "react-jss";
import { IUserOrganization } from "Application/features/models/Multitenancy/IUserOrganization";
import { useGetUserOrganizationByUserIdMutation } from "Application/features/services/apis/Multitenancy/UserOrganizationServiceApi";
import { Paperclip } from "react-feather";

/**
 *  Returns the page for the inbox and the outbox
 *
 * @remarks
 * This Inbox component is the first page to be rendered upon login
 *
 * @return JSX element
 */

const myStyles = createUseStyles({
    rowStyle: {
        marginBottom: "0.5em"
    }
});

const IssueReportForm = () => {
    /**
     * Save  hook generated by @see BranchServiceApi
     * points to the save enpoint.
     */
    const [save] = useSaveReportMutation();
    const [update] = useUpdateReportMutation();
    const classes = myStyles();

    /**
     * genericMethods is generic method, property  generator tha returns
     * default/ generic event handlers for a setup form.
     * @prop Name is defaulted as the name of the setup and shown on the form.
     * @prop saveMethod - a save endpoint/ function for the setup.
     * @prop removeMethod - points to the remove method, endpoint for the setup.
     * @prop updateMethod - points to the update method / endpont for the setup.
     * @returns generic methods / properties for setup form.
     * @type IBranch
     * **/
    const genericMethods = useGenericFormMethods<IIssue>({
        formName: "Issue Reporting",
        saveMethod: save,
        // deleteMethod: remove,
        updateMethod: update,
        // searchMethod: search,
        isParent: true
    });

    const { formHandler } = genericMethods;

    const defaultTextSpace = "";

    const [wscontent, setwsContent] = useState<string>(defaultTextSpace);

    function handleWsChange(value: string) {
        value == defaultTextSpace.toString() || !value ? setwsContent(defaultTextSpace) : setwsContent(value);

        formHandler.setValue("description", value);
        console.log({ description: value });
    }
    const [getUserOrganizationsByUserId] = useGetUserOrganizationByUserIdMutation();

    const getUserOrganizations = async () => {
        const userId = userManagementUtil.getUserId();
        const response: { data: IUserOrganization[] } | any = await getUserOrganizationsByUserId(userId);
        if (response && response?.data && response.data.length) {
            return response.data[0];
        }
        return false;
    };
    //console.log(userManagementUtil.getUserSession());
    const saveIssue = async () => {
        await genericMethods.formHandler.handleSubmit(async (form) => {
            ShowInfoConfirmation("Are you sure you want to add new policy?", async () => {
                const userInfo = userManagementUtil.getUserSession();
                const organisation = await getUserOrganizations();
                if (!organisation) return growlWarning("User Is not assigned to an organisation.");
                let formData = form;
                formData.createdBy = userInfo.userName;
                formData.createdDate = new Date().toJSON();
                formData.companyId = userInfo.companyId;
                formData.companyName = userInfo.companyName;
                const { data }: any = await save([formData as IIssue]);
                if (data && data.length) {
                    genericMethods.setModel(data[0]);
                    genericMethods.setOpen(true);
                    //genericMethods.formHandler.reset({});
                }
            });
        })();
    };
    return (
        <>
            <div className="App-header">
                <Card sx={{ width: "90%", height: "90%", margin: "5em" }}>
                    <CardContent>
                        <Typography variant="h5" component="div">
                            Siba Issue Report Form
                        </Typography>
                        <hr />
                        <Box sx={{ width: "75%" }}>
                            <>
                                <div style={{ width: "100%", margin: "1em" }}>
                                    <div className={`row ${classes.rowStyle}`}>
                                        <div className="col-sm-4">
                                            <div style={{ width: "100%" }}>
                                                <SibaInput
                                                    name="reportedBy"
                                                    label="Issue Reported By"
                                                    type="text"
                                                    validationObj={{ required: true }}
                                                    formHandler={formHandler}
                                                    value={userManagementUtil.getFullname()}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <SibaSelect
                                                name="applicationName"
                                                label="Application"
                                                formHandler={formHandler}
                                                validationObj={{ required: true }}
                                                optionsObj={[
                                                    { label: "Sibagen", value: "Sibagen" },
                                                    { label: "SibaBroker", value: "Sibabroker" },
                                                    { label: "Whatsapp ChatBot", value: "Whatsapp ChatBot" }
                                                ]}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <SibaSelect
                                                name="category"
                                                label="Category of Issue"
                                                formHandler={formHandler}
                                                validationObj={{ required: true }}
                                                optionsObj={[
                                                    { label: "Underwriting", value: "Underwriting" },
                                                    { label: "Reinsurance", value: "Reinsurance" },
                                                    { label: "Claim", value: "Claim" },
                                                    { label: "Account", value: "Account" },
                                                    { label: "Other", value: "Other" }
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    <div className={`row ${classes.rowStyle}`}>
                                        <div className="col-sm-4">
                                            {" "}
                                            <SibaSelect
                                                name="Priority"
                                                label="Priority"
                                                formHandler={formHandler}
                                                validationObj={{ required: true }}
                                                optionsObj={[
                                                    { label: "Normal", value: "Normal" },
                                                    { label: "Intermediate", value: "Intermediate" },
                                                    { label: "High", value: "High" }
                                                ]}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            {" "}
                                            <SibaDatePicker name="expectedResolutionDate" label="Expected Date of Resolution" formHandler={formHandler} />
                                        </div>
                                    </div>

                                    <div className={`row ${classes.rowStyle}`}>
                                        <div className="col-sm-12">
                                            <SibaInput name="subject" label="Subject" type="text" validationObj={{ required: true }} formHandler={formHandler} />
                                        </div>
                                        <div className=""></div>
                                    </div>
                                </div>
                            </>
                        </Box>
                        <div style={{ margin: "1em" }}>
                            <ReactQuill value={wscontent} onChange={handleWsChange} />
                        </div>
                    </CardContent>
                    <CardActions>
                        <Button size="" variant="contained" onClick={saveIssue}>
                            Report Issue
                        </Button>
                    </CardActions>
                </Card>
            </div>
            <SmallScreenDialog
                visible={genericMethods.modalOpen}
                onClose={() => {
                    genericMethods.setOpen(false);
                }}
            >
                <div className="row" style={{ padding: "4em" }}>
                    <div className="col-md-9">
                        <Typography variant="h6" gutterBottom>
                            Click button to attach relevant documents to issue.
                        </Typography>
                    </div>
                    <div className="col-md-3">
                        <Button
                            variant="contained"
                            color="info"
                            style={{ color: "white" }}
                            onClick={() => {
                                // if (!genericMethods.model.id) {
                                //     return growlInfo("Please select a record from the grid.");
                                // }

                                DocumentManagerActions.handleDocuments({
                                    transactionId: genericMethods.model.id || "",
                                    transactionName: "Document Upload"
                                });
                            }}
                            startIcon={<Paperclip size={18} />}
                            // disabled={genericMethods.model.id ? false : true}
                        >
                            Attach Document
                        </Button>
                    </div>
                </div>
            </SmallScreenDialog>
        </>
    );
};

export default IssueReportForm;
